// extracted by mini-css-extract-plugin
export var boxItems = "_bz-1";
export var boxItemsLg = "_bz-2";
export var button = "_bz-7";
export var buttonLg = "_bz-8";
export var filterGroupBox = "_bz-0";
export var icon = "_bz-3";
export var iconSecondary = "_bz-6";
export var iconWrapper = "_bz-4";
export var iconWrapperLg = "_bz-5";